<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Общая информация
        </h4>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Название">
                <b-form-input
                  v-model="subscription.name"
                  placeholder="Название"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Максимальное количество абонементов">
                <b-form-input
                  v-model.number="subscription.maxAmount"
                  type="number"
                  no-wheel
                  placeholder="Максимальное кол-во абонементов"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Вид абонемента">
                <b-form-input
                  v-model="subscription.type"
                  placeholder="Вид абонемента"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Количество тренировок"
                description="Сколько занятий входит в абонемент. Показывается на сайте и делит цену на стоимость одного занятия."
              >
                <b-form-input
                  v-model.number="subscription.lessonsCount"
                  type="number"
                  min="1"
                  no-wheel
                  placeholder="Например, 8"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Срок действия, дней"
                description="4 недели — это 28 дней. Пусто — срок не показываем."
              >
                <b-form-input
                  v-model.number="subscription.validityDays"
                  type="number"
                  min="1"
                  no-wheel
                  placeholder="Например, 28"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Цвет">
                <b-dropdown
                  :text="getSelectedColor()"
                  variant="primary"
                  class="w-100"
                  menu-class="w-100"
                >
                  <b-dropdown-item
                    v-for="value in colorList"
                    :key="value.color"
                    class="w-100"
                    @click="subscription.color = value.color"
                  >
                    {{ value.label }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Вид тренировки">
                <v-select
                  v-model="workoutOption"
                  :close-on-select="true"
                  :options="workoutOptions"
                  :reduce="workoutOption => workoutOption"
                  label="type"
                  input-id="type"
                  :value="workoutOption"
                  class="select"
                  @search="
                    (search, loading) => getWorkouts(search, loading)
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card">
        <div
          v-if="subscription.photo"
          class="card-body"
        >
          <img
            :src="subscription.photo.fullPath"
            alt="picture"
            class="image"
          >
        </div>
        <div class="card-body">
          <div class="upload-wrap">
            <file-uploader
              v-model="subscription.photo"
              :default="subscription.photo"
              title="Картинка"
              @updatePhotos="getPhotos"
            />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header" />
        <div class="card-body">
          <h4 class="card-title">
            Описание
          </h4>
          <div class="my-1">
            Описание
          </div>
          <quill-editor v-model="subscription.description" />
        </div>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Цена">
                <b-form-input
                  v-model.number="subscription.price"
                  placeholder="Цена"
                  type="number"
                  no-wheel
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div class="card-body">
        <b-form-checkbox v-model="subscription.isPriseDependsOnCount">
          Цена зависит от количества
        </b-form-checkbox>

        <b-button
          v-if="subscription.isPriseDependsOnCount"
          variant="primary"
          class="mt-2"
          @click="addEmptyDiscount"
        >
          Добавить скидку
        </b-button>
      </div>

      <div
        v-if="subscription.isPriseDependsOnCount"
        class="card-body"
      >
        <div
          v-for="(discount, index) in subscription.discounts"
          :key="discount.id"
          class="mb-2"
        >
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group :label="'Скидка, %'">
                  <b-form-input
                    v-model.number="discount.sale"
                    placeholder="Скидка, %"
                    type="number"
                    no-wheel
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Количество">
                  <b-form-input
                    v-model.number="discount.amount"
                    placeholder="Количество"
                    type="number"
                    no-wheel
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group
                  v-slot="{ ariaDescribedby }"
                  label="Тип скидки"
                >
                  <b-form-radio
                    v-for="type in discountTypes"
                    :key="type.value"
                    v-model="discount.type"
                    class="mb-1"
                    :aria-describedby="ariaDescribedby"
                    :value="type.value"
                  >
                    {{ type.label }}
                  </b-form-radio>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <b-button
            variant="danger"
            class="mt-2"
            @click="deleteDiscount(index)"
          >
            Удалить скидку
          </b-button>
          <div class="divider" />
        </div>
      </div>
    </div>

    <b-col>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1 save-button"
        :disabled="isloading"
        @click="saveItem"
      >
        <b-spinner
          v-if="isloading"
          small
        />
        {{ isloading ? 'Сохранение...' : 'Сохранить' }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BRow,
  BSpinner,
  VBPopover,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Russian } from 'flatpickr/dist/l10n/ru'
import crud_module from '../../../libs/crud_module'
import FileUploader from '@/global-components/FileUploader.vue'

const subscription_module = crud_module({
  entity_name: 'subscription',
})

const workouts_module = crud_module({
  entity_name: 'workout',
})

export default {
  name: 'SchedulePage',
  components: {
    BFormRadio,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    FileUploader,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian, // locale for this instance only
      },
      colorList: {
        BLUE: {
          color: 'blue',
          label: 'Синий',
        },
        PURPLE: {
          color: 'purple',
          label: 'Фиолетовый',
        },
        GREEN: {
          color: 'green',
          label: 'Зелёный',
        },
        ORANGE: {
          color: 'orange',
          label: 'Оранжевый',
        },
      },
      months: [
        'январь',
        'февраль',
        'март',
        'апрель',
        'май',
        'июнь',
        'июль',
        'август',
        'сентябрь',
        'октябрь',
        'ноябрь',
        'декабрь',
      ],
      isloading: false,
      downloadDisabled: false,
      subscription: {
        color: null,
        isPriseDependsOnCount: false,
        photo: null,
        maxAmount: null,
        // объявлены здесь, иначе Vue 2 не отследит их появление после загрузки абонемента
        lessonsCount: null,
        validityDays: null,
        discounts: [],
      },
      discountTypes: [
        {
          value: 'equals',
          label: 'Количество равно выбранному числу',
        },
        {
          value: 'from',
          label: 'Количество больше выбранного числа',
        },
      ],
      workoutOptions: [],
      defaultWorkoutOptions: [],
      workoutOption: null,
      debounce: null,
    }
  },
  watch: {
    workoutOption() {
      this.subscription.workoutId = this.workoutOption?.id
    },
  },
  async created() {
    await workouts_module.fetchItems().then(result => {
      this.workoutOptions = result.data.rows
      this.defaultWorkoutOptions = result.data.rows
    })
    if (this.$route.params.id === 'new') {
      return
    }
    try {
      await subscription_module
        .fetchItem(this.$route.params.id, {
          query: {
            admin: '1',
          },
        })
        .then(result => {
          this.subscription = result.data
          this.workoutOption = result.data.workout
        })
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    deleteDiscount(index) {
      console.log(index)
      this.subscription.discounts.splice(index, 1)
    },
    addEmptyDiscount() {
      this.subscription.discounts.push({
        amount: 0,
        sale: 0,
        type: 'equals',
      })
    },
    getSelectedColor() {
      return (
        Object.values(this.colorList).find(
          c => c.color === this.subscription.color,
        )?.label ?? 'Цвет'
      )
    },
    getPhotos(data) {
      if (data) {
        this.subscription.photoId = data.id
        this.subscription.photo = data
      } else {
        this.subscription.photoId = null
        this.subscription.photo = null
      }
    },
    saveItem() {
      if (!this.subscription.maxAmount) {
        this.subscription.maxAmount = null
      }
      // Пустое число в b-form-input приходит как '' — бэк ждёт либо целое, либо отсутствие поля
      if (!this.subscription.lessonsCount) {
        this.subscription.lessonsCount = null
      }
      if (!this.subscription.validityDays) {
        this.subscription.validityDays = null
      }
      this.subscription.kindOfSportId = null
      delete this.subscription.kindOfSport

      if (this.$route.params.id === 'new') {
        this.create()
      } else {
        this.update()
      }
    },
    async update() {
      try {
        await subscription_module
          .updateItem(this.subscription.id, this.subscription)
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Абонемент сохранен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'subscriptions' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
    async create() {
      try {
        await subscription_module
          .createItem(this.subscription)
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Абонемент добавлен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'subscriptions' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
    debounceSearch(search, loading, fn) {
      clearTimeout(this.debounce)
      if (search.length > 0) {
        this.debounce = setTimeout(fn, 600)
      } else {
        this.workoutOptions = this.defaultWorkoutOptions
      }
    },
    getWorkouts(search, loading) {
      this.debounceSearch(search, loading, async () => {
        try {
          await workouts_module
            .fetchItems({ filterText: search })
            .then(result => {
              this.workoutOptions = result.data.rows
              loading(false)
            })
        } catch (e) {
          console.error(e)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.image {
  max-width: 100%;
  max-height: 300px;
}
</style>
